"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _reactDom = require("react-dom");

var _lodash = _interopRequireDefault(require("lodash.uniq"));

var _lodash2 = _interopRequireDefault(require("lodash.flatten"));

var _lodash3 = _interopRequireDefault(require("lodash.takeright"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

require("./_recent-posts-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RecentPostsList = /*#__PURE__*/function (_Component) {
  _inherits(RecentPostsList, _Component);

  function RecentPostsList(props) {
    var _this;

    _classCallCheck(this, RecentPostsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecentPostsList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getDisplayedPosts", (0, _memoizeOne.default)(function (posts, tags) {
      return tags.size ? _this.getFilteredPosts(tags) : _toConsumableArray(posts);
    }));

    _defineProperty(_assertThisInitialized(_this), "getFilteredPosts", function (selectedTags) {
      var posts = _this.props.posts;
      return posts.filter(function (post) {
        var tag = post.tagLine || '';
        var postTags = tag.split(',');
        return postTags.some(function (postTag) {
          return selectedTags.has(postTag.toUpperCase());
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTagClick", function (tag) {
      return function () {
        var selectedTags = _this.state.selectedTags;
        var updatedSelectedTags = new Set(_toConsumableArray(selectedTags));

        if (updatedSelectedTags.has(tag)) {
          updatedSelectedTags.delete(tag);
        } else {
          updatedSelectedTags.add(tag);
        }

        _this.setState({
          selectedTags: updatedSelectedTags
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderPostTags", function () {
      var posts = _this.props.posts;
      var selectedTags = _this.state.selectedTags;
      var tags = (0, _lodash3.default)((0, _lodash.default)((0, _lodash2.default)(posts.map(function (_ref) {
        var tagLine = _ref.tagLine;
        return tagLine ? tagLine.split(',') : '';
      }))), 10).filter(Boolean);

      if (!tags.length) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "recent-posts-list__tags"
      }, tags.map(function (tag) {
        return _react.default.createElement(_uiKit.Button, {
          type: selectedTags.has(tag) ? 'PRIMARY' : 'TERTIARY',
          key: tag,
          onClick: _this.onTagClick(tag)
        }, "#".concat(tag));
      }));
    });

    _this.state = {
      selectedTags: new Set()
    };
    return _this;
  }

  _createClass(RecentPostsList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          history = _this$props.history,
          renderCardItem = _this$props.renderCardItem,
          onFiltersChange = _this$props.onFiltersChange,
          error = _this$props.error,
          posts = _this$props.posts,
          loading = _this$props.loading;
      var selectedTags = this.state.selectedTags;
      var listContent = document.querySelector('.list-container > div:nth-child(2)');
      var displayedPosts = this.getDisplayedPosts(posts, selectedTags);

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      return _react.default.createElement("div", {
        className: "recent-posts-list"
      }, listContent && (0, _reactDom.createPortal)(this.renderPostTags(), listContent), _react.default.createElement(_uiKit.List, {
        history: history,
        renderCardItem: renderCardItem,
        onFiltersChange: onFiltersChange,
        data: displayedPosts,
        hideInspiration: true,
        loading: loading,
        listKey: "inspirationId",
        filtersRightAddon: _react.default.createElement(_uiKit.Text, {
          noMargin: true,
          heading3: true,
          prefixIcon: "guide"
        }, "Recent Posts")
      }));
    }
  }]);

  return RecentPostsList;
}(_react.Component);

exports.default = RecentPostsList;